export interface PlayResult {
  success: boolean;
  message?: string;
}

export interface PlayTrackOptions {
  trackUri?: string;
  albumUri?: string;
  positionMs?: number;
}

export interface PlaybackRequest {
  context_uri?: string;
  offset?: { uri: string };
  uris?: string[];
  position_ms?: number;
}

export async function playOnDevice(
  request: PlaybackRequest,
  accessToken: string,
  deviceId: string
): Promise<PlayResult> {
  try {
    const response = await fetch('/api/spotify/play-track', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        ...request,
        device_id: deviceId,
      }),
    });

    if (response.ok) return { success: true };

    const errorData = await response.json().catch(() => ({}));
    return {
      success: false,
      message: errorData.error?.message || 'Spotify could not start playback in Music Man.',
    };
  } catch (error: any) {
    return {
      success: false,
      message: error?.message || 'Could not connect to Spotify.',
    };
  }
}
